import { CURRENCIES } from "../../constants/currency";

export default function CurrencySwitch({ displayCurrency, onChange }) {
  const isBrl = displayCurrency === CURRENCIES.BRL;
  const nextCurrency = isBrl ? CURRENCIES.USD : CURRENCIES.BRL;

  return (
    <button
      className="currency-toggle"
      type="button"
      onClick={() => onChange(nextCurrency)}
      title={isBrl ? "Exibir em dolar" : "Exibir em real"}
      aria-label={isBrl ? "Exibir em dolar" : "Exibir em real"}
      aria-pressed={!isBrl}
      data-active-currency={displayCurrency}
    >
      <span className="currency-toggle__label currency-toggle__label--brl">
        R$
      </span>
      <span className="currency-toggle__label currency-toggle__label--usd">
        $
      </span>
      <span className="currency-toggle__thumb" aria-hidden="true" />
    </button>
  );
}
